import { render } from "./ListRadios.vue?vue&type=template&id=5bbdf433&scoped=true"
import script from "./ListRadios.vue?vue&type=script&lang=js"
export * from "./ListRadios.vue?vue&type=script&lang=js"

import "./ListRadios.vue?vue&type=style&index=0&id=5bbdf433&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5bbdf433"

export default script